document.addEventListener('DOMContentLoaded', function(){
  const hdr=document.getElementById('mainHeader');
  function onScroll(){ if(!hdr) return; if(window.scrollY>40) hdr.classList.add('hdr-scrolled'); else hdr.classList.remove('hdr-scrolled'); }
  onScroll(); window.addEventListener('scroll',onScroll,{passive:true});

  document.querySelectorAll('[data-mob-open]').forEach(btn=>btn.addEventListener('click',openMobSidebar));
  document.querySelectorAll('[data-mob-close]').forEach(btn=>btn.addEventListener('click',closeMobSidebar));
  document.addEventListener('keydown',e=>{ if(e.key==='Escape') closeMobSidebar(); });

  const chat=document.getElementById('waChat');
  document.querySelectorAll('[data-chat-toggle]').forEach(btn=>btn.addEventListener('click',()=>chat?.classList.toggle('open')));

  document.querySelectorAll('.cart-link').forEach(link=>link.addEventListener('click',function(e){
    if(window.matchMedia('(min-width: 769px)').matches){ return; }
  }));

  initFadeIn();
  hydrateWishlistButtons();
});

function openMobSidebar(){
  const sidebar=document.getElementById('mobSidebar');
  sidebar?.classList.add('open');
  sidebar?.setAttribute('aria-hidden','false');
  sidebar?.removeAttribute('inert');
  document.getElementById('mobOverlay')?.classList.add('open');
  document.body.classList.add('menu-open');
}
function closeMobSidebar(){
  const sidebar=document.getElementById('mobSidebar');
  sidebar?.classList.remove('open');
  sidebar?.setAttribute('aria-hidden','true');
  sidebar?.setAttribute('inert','');
  document.getElementById('mobOverlay')?.classList.remove('open');
  document.body.classList.remove('menu-open');
}

function pcardQty(btn, delta){
  var ctrl=btn.closest('.pcard-qty-ctrl'); if(!ctrl) return;
  var input=ctrl.querySelector('.pcard-qty-num'); var val=parseInt(input.value)||1;
  input.value=Math.max(1,Math.min(99,val+delta));
  var minus=ctrl.querySelectorAll('.pcard-qty-btn')[0]; if(minus) minus.style.opacity=input.value<=1?'0.45':'1';
}

function formatMoney(cents){
  try{
    if(window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
  }catch(e){}
  return 'Rs. ' + (Number(cents||0)/100).toLocaleString('en-PK',{maximumFractionDigits:0});
}
function showCartToast(msg){
  document.querySelectorAll('.cart-toast').forEach(t=>t.remove());
  var t=document.createElement('div'); t.className='cart-toast'; t.textContent=msg||'✅ Added to cart!';
  document.body.appendChild(t); setTimeout(()=>t.remove(),2200);
}
function updateBadges(count){
  document.querySelectorAll('.cart-count,.cart-badge,.mob-cart-count').forEach(function(b){
    b.textContent=count; b.style.display=count>0?'flex':'none';
  });
  document.querySelectorAll('.cart-dd-count').forEach(el=>el.textContent=count);
}
function renderMiniCart(cart){
  const dd=document.getElementById('cartDropdown'); if(!dd||!cart) return;
  const body=dd.querySelector('.cart-dd-body'); if(!body) return;
  if(!cart.items || cart.items.length===0){
    body.innerHTML='<div class="cart-dd-empty"><div>🛒</div><p>Your cart is empty</p><a href="/collections/all">Start Shopping</a></div>'; return;
  }
  const items=cart.items.slice(0,3).map(item=>{
    const img=item.image?`<img src="${item.image}" alt="">`:'<div class="cart-dd-noimg">🌿</div>';
    const title=(item.product_title||item.title||'Product').slice(0,34);
    return `<div class="cart-dd-item">${img}<div><strong>${title}</strong><span>${item.quantity} × ${formatMoney(item.final_price||item.price)}</span></div></div>`;
  }).join('');
  body.innerHTML=items+`<div class="cart-dd-total"><span>Subtotal</span><strong>${formatMoney(cart.total_price)}</strong></div><div class="cart-dd-actions"><a href="/cart">View Cart</a><a href="/checkout">Checkout</a></div>`;
}
function updateCartCount(){
  return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(r=>r.json()).then(cart=>{updateBadges(cart.item_count);renderMiniCart(cart);return cart;});
}
function afAddVariantToCart(variantId, qty, redirect){
  return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:Number(variantId),quantity:qty||1})})
    .then(r=>{ if(!r.ok) throw new Error('Cart add failed'); return r.json(); })
    .then(()=>{ if(redirect) { location.href='/checkout'; return; } return updateCartCount().then(()=>showCartToast('✅ Added to cart!')); });
}
function getCardVariant(btn){
  var card=btn.closest('[data-product-card]')||btn.closest('.pcard')||btn.closest('.pc')||document;
  var input=card.querySelector('.pcard-variant');
  var qty=parseInt(card.querySelector('.pcard-qty-num')?.value||1);
  return {variantId:input?.value, qty:qty};
}
function addToCartFromCard(btn){
  var data=getCardVariant(btn); if(!data.variantId) return;
  btn.disabled=true; var old=btn.innerHTML; btn.innerHTML='✓';
  afAddVariantToCart(data.variantId, data.qty, false).then(()=>{setTimeout(()=>{btn.innerHTML=old;btn.disabled=false},900)}).catch(()=>{btn.innerHTML='!';setTimeout(()=>{btn.innerHTML=old;btn.disabled=false},1200)});
}
function buyNowFromCard(btn){
  var data=getCardVariant(btn); if(!data.variantId) return;
  btn.disabled=true; afAddVariantToCart(data.variantId, data.qty, true).catch(()=>{btn.disabled=false});
}
function addToCartVariant(variantId, btn){
  var body=btn.closest('.pcard-body')||btn.closest('.pbody')||document;
  var qty=parseInt(body.querySelector('.pcard-qty-num')?.value||1);
  btn.disabled=true; var old=btn.innerHTML; btn.innerHTML='✓';
  afAddVariantToCart(variantId, qty, false).then(()=>{setTimeout(()=>{btn.innerHTML=old;btn.disabled=false},900)}).catch(()=>{btn.innerHTML=old;btn.disabled=false});
}
function buyNowVariant(variantId, btn){ afAddVariantToCart(variantId, 1, true); }
function changeImg(el, src){ document.getElementById('mainImg')?.setAttribute('src',src); document.querySelectorAll('.af-thumb-button').forEach(t=>t.classList.remove('active')); el.classList.add('active'); }

function getWishlist(){ try{return JSON.parse(localStorage.getItem('afWishlist')||'[]')}catch(e){return []} }
function saveWishlist(list){ localStorage.setItem('afWishlist',JSON.stringify(list)); }
function toggleWish(handle, btn){
  if(!handle) return; let list=getWishlist(); const exists=list.includes(handle);
  list=exists?list.filter(x=>x!==handle):list.concat(handle); saveWishlist(list);
  if(btn){btn.classList.toggle('wl-active',!exists); btn.textContent=!exists?'❤️':'🤍';}
  showCartToast(!exists?'❤️ Added to wishlist':'Removed from wishlist');
}
function hydrateWishlistButtons(){
  const list=getWishlist();
  document.querySelectorAll('.wish-btn,.pcard-quick button').forEach(btn=>{
    const onclick=btn.getAttribute('onclick')||''; const m=onclick.match(/toggleWish\('([^']+)'/); if(m&&list.includes(m[1])){btn.classList.add('wl-active');btn.textContent='❤️';}
  });
}
function initFadeIn(){
  const els=document.querySelectorAll('.fade-in'); if(!els.length) return;
  if(!('IntersectionObserver' in window)){els.forEach(e=>e.classList.add('visible')); return;}
  const obs=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('visible'); obs.unobserve(e.target);}})},{threshold:.12});
  els.forEach(el=>obs.observe(el));
}

(function(){
  let cur=0, pct=0, intv=null, pIntv=null; const DELAY=7000;
  function initHeroSlider(){
    const slides=document.querySelectorAll('.vslide'); const tabs=document.querySelectorAll('.stab'); const vsNum=document.getElementById('vsNum'); const vsProg=document.getElementById('vsProg');
    if(!slides.length) return;
    function go(n){
      slides[cur]?.classList.remove('active'); tabs[cur]?.classList.remove('on');
      cur=((n%slides.length)+slides.length)%slides.length; slides[cur]?.classList.add('active'); tabs[cur]?.classList.add('on');
      if(vsNum) vsNum.textContent=String(cur+1).padStart(2,'0'); pct=0; if(vsProg) vsProg.style.width='0%'; clearInterval(intv); clearInterval(pIntv); start();
    }
    function start(){ pIntv=setInterval(()=>{pct+=100/(DELAY/50); if(vsProg) vsProg.style.width=Math.min(pct,100)+'%';},50); intv=setInterval(()=>go(cur+1),DELAY); }
    tabs.forEach((tab,i)=>tab.addEventListener('click',()=>go(i))); start();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initHeroSlider); else initHeroSlider();
})();


// Original About page scroll reveal animation
(function(){
  function initAboutPageAnimations(){
    if(!('IntersectionObserver' in window)) return;
    const els=document.querySelectorAll('.t-card,.val-card,.stat-box,.d-stat');
    if(!els.length || document.body.dataset.aboutObserverReady==='1') return;
    document.body.dataset.aboutObserverReady='1';
    const observer=new IntersectionObserver((entries)=>{
      entries.forEach(e=>{
        if(e.isIntersecting){
          e.target.style.opacity='1';
          e.target.style.transform='translateY(0)';
          observer.unobserve(e.target);
        }
      });
    },{threshold:0.1});
    els.forEach(el=>{
      el.style.opacity='0';
      el.style.transform='translateY(20px)';
      el.style.transition='all 0.6s ease';
      observer.observe(el);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initAboutPageAnimations); else initAboutPageAnimations();
})();

// Cart page quantity controls
(function(){
  function initCartPageQty(){
    document.querySelectorAll('[data-cart-minus],[data-cart-plus]').forEach(function(btn){
      if(btn.dataset.boundCartQty === '1') return;
      btn.dataset.boundCartQty = '1';
      btn.addEventListener('click', function(){
        var wrap = btn.closest('.af-cart-qty');
        var input = wrap && wrap.querySelector('.af-cart-qty-input');
        if(!input) return;
        var value = parseInt(input.value, 10);
        if(isNaN(value)) value = 1;
        value += btn.hasAttribute('data-cart-plus') ? 1 : -1;
        input.value = Math.max(0, value);
      });
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCartPageQty); else initCartPageQty();
})();



// Robust product and product-card variant handling
(function(){
  function bool(v){ return v === true || v === 'true'; }
  function setText(el, text){ if(el) el.textContent = text || ''; }
  function toggleHidden(el, hidden){ if(el) el.classList.toggle('is-hidden', !!hidden); }
  function optionImage(option){ return option && option.getAttribute ? option.getAttribute('data-image') : ''; }
  function optionPrice(option){ return Number(option && option.getAttribute ? option.getAttribute('data-price') : 0) || 0; }
  function optionCompare(option){ return Number(option && option.getAttribute ? option.getAttribute('data-compare-at-price') : 0) || 0; }
  function optionAvailable(option){ return bool(option && option.getAttribute ? option.getAttribute('data-available') : true); }

  function updateCardFromVariant(select){
    const card = select.closest('[data-product-card]');
    if(!card) return;
    const option = select.options ? select.options[select.selectedIndex] : select;
    if(!option) return;
    const price = optionPrice(option);
    const compare = optionCompare(option);
    const available = optionAvailable(option) && !option.disabled;
    const imgSrc = optionImage(option);

    setText(card.querySelector('[data-card-price], .pcard-now, .pnow'), formatMoney(price));
    const old = card.querySelector('[data-card-compare-price], .pcard-old, .pold');
    if(old){
      if(compare > price){ old.textContent = formatMoney(compare); old.classList.remove('is-hidden'); }
      else { old.textContent = ''; old.classList.add('is-hidden'); }
    }
    const img = card.querySelector('[data-card-image]');
    if(img && imgSrc) img.src = imgSrc;

    card.classList.toggle('pcard--soldout', !available);
    const qtyRow = card.querySelector('[data-card-qty-row], .pcard-qty-row');
    if(qtyRow) qtyRow.classList.toggle('is-disabled', !available);
    card.querySelectorAll('.pcard-qty-btn,.pcard-qty-num').forEach(function(el){ el.disabled = !available; });

    const actions = card.querySelector('[data-card-actions], .pcard-actions');
    if(actions){
      actions.innerHTML = available
        ? '<button class="pcard-cart" onclick="addToCartFromCard(this)" aria-label="Add to cart"><i class="fas fa-cart-plus"></i></button><button class="pcard-buy" onclick="buyNowFromCard(this)" aria-label="Buy now"><i class="fas fa-bolt"></i> Buy Now</button>'
        : '<button class="pcard-soldout" disabled>Sold Out</button>';
    }
  }

  function getVariantById(variants, id){
    return variants.find(function(v){ return String(v.id) === String(id); });
  }
  function getSelectedOptionValues(root){
    const groups = Array.from(root.querySelectorAll('.af-option-group'));
    return groups.map(function(group){
      const active = group.querySelector('[data-product-option-button].is-active');
      return active ? active.getAttribute('data-option-value') : '';
    });
  }
  function findVariantByOptions(variants, selected){
    return variants.find(function(variant){
      if(!variant.options || variant.options.length !== selected.length) return false;
      return variant.options.every(function(value, i){ return String(value) === String(selected[i]); });
    });
  }
  function setProductButtonState(root, available){
    root.querySelectorAll('[data-product-add-icon],[data-product-add-main]').forEach(function(btn){ btn.disabled = !available; });
    setText(root.querySelector('[data-product-add-text]'), available ? 'Add to Cart' : 'Sold Out');
    const err = root.querySelector('[data-variant-error]');
    if(err) err.style.display = available ? 'none' : 'block';
  }
  function updateProductFromVariant(root, variant, updateUrl){
    if(!variant) { setProductButtonState(root, false); return; }
    const select = root.querySelector('[data-product-variant-select]');
    if(select) select.value = variant.id;

    setText(root.querySelector('[data-product-price]'), formatMoney(variant.price));
    const compare = Number(variant.compare_at_price || 0);
    const price = Number(variant.price || 0);
    const old = root.querySelector('[data-product-compare-price]');
    const save = root.querySelector('[data-product-save]');
    if(compare > price){
      if(old){ old.textContent = formatMoney(compare); old.classList.remove('is-hidden'); }
      if(save){ save.textContent = 'Save ' + formatMoney(compare - price); save.classList.remove('is-hidden'); }
    }else{
      if(old){ old.textContent = ''; old.classList.add('is-hidden'); }
      if(save){ save.textContent = ''; save.classList.add('is-hidden'); }
    }

    const availableText = variant.available ? 'In Stock' : 'Sold Out';
    setText(root.querySelector('[data-product-availability]'), availableText);
    setText(root.querySelector('[data-product-availability-text]'), variant.available ? 'In stock' : 'Sold out');
    setProductButtonState(root, !!variant.available);

    const skuRow = root.querySelector('[data-product-sku-row]');
    const sku = root.querySelector('[data-product-sku]');
    if(sku){ sku.textContent = variant.sku || ''; }
    if(skuRow) skuRow.classList.toggle('is-hidden', !variant.sku);

    const img = root.querySelector('[data-main-product-image]');
    const selectedOption = select && select.options ? select.options[select.selectedIndex] : null;
    const selectedOptionImage = optionImage(selectedOption);
    if(img && selectedOptionImage){
      img.src = selectedOptionImage;
    }else if(img && variant.featured_image && variant.featured_image.src){
      img.src = variant.featured_image.src;
    }

    if(updateUrl && window.history && window.history.replaceState){
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }
  function setOptionButtonsFromVariant(root, variant){
    if(!variant || !variant.options) return;
    variant.options.forEach(function(value, index){
      const group = root.querySelector('.af-option-group[data-option-index="' + index + '"]');
      if(!group) return;
      group.querySelectorAll('[data-product-option-button]').forEach(function(btn){
        const active = String(btn.getAttribute('data-option-value')) === String(value);
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    });
  }
  function initProductVariantPicker(){
    document.querySelectorAll('[data-product-detail]').forEach(function(root){
      if(root.dataset.variantsReady === '1') return;
      root.dataset.variantsReady = '1';
      const json = root.querySelector('[data-product-variants-json]');
      const select = root.querySelector('[data-product-variant-select]');
      if(!json || !select) return;
      let variants = [];
      try{ variants = JSON.parse(json.textContent || '[]'); }catch(e){ variants = []; }
      if(!variants.length) return;

      const urlVariant = new URLSearchParams(window.location.search).get('variant');
      const initial = getVariantById(variants, urlVariant) || getVariantById(variants, select.value) || variants.find(v => v.available) || variants[0];
      setOptionButtonsFromVariant(root, initial);
      updateProductFromVariant(root, initial, false);

      root.querySelectorAll('[data-product-option-button]').forEach(function(btn){
        btn.addEventListener('click', function(){
          const group = btn.closest('.af-option-group');
          if(!group) return;
          group.querySelectorAll('[data-product-option-button]').forEach(function(b){ b.classList.remove('is-active'); b.setAttribute('aria-pressed','false'); });
          btn.classList.add('is-active'); btn.setAttribute('aria-pressed','true');
          const variant = findVariantByOptions(variants, getSelectedOptionValues(root));
          updateProductFromVariant(root, variant, true);
        });
      });

      select.addEventListener('change', function(){
        const variant = getVariantById(variants, select.value);
        setOptionButtonsFromVariant(root, variant);
        updateProductFromVariant(root, variant, true);
      });
    });
  }
  function initCardVariantPickers(){
    document.querySelectorAll('[data-card-variant-select], .pcard-variant').forEach(function(select){
      if(select.dataset.cardVariantReady === '1' || !select.options) return;
      select.dataset.cardVariantReady = '1';
      updateCardFromVariant(select);
      select.addEventListener('change', function(){ updateCardFromVariant(select); });
    });
  }
  function initAllVariants(){ initProductVariantPicker(); initCardVariantPickers(); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllVariants); else initAllVariants();
  document.addEventListener('shopify:section:load', initAllVariants);
})();

// Product detail form handling: icon button adds to cart, main button buys now.
(function(){
  function initProductForms(){
    document.querySelectorAll('.af-product-form').forEach(function(form){
      if(form.dataset.productFormReady === '1') return;
      form.dataset.productFormReady = '1';
      var lastSubmitter = null;
      form.querySelectorAll('[type="submit"]').forEach(function(btn){
        btn.addEventListener('click', function(){ lastSubmitter = btn; });
      });
      form.addEventListener('submit', function(e){
        var submitter = e.submitter || lastSubmitter;
        if(!submitter || !submitter.matches('[data-product-add-icon],[data-product-add-main]')) return;
        e.preventDefault();
        if(submitter.disabled) return;
        var variantInput = form.querySelector('[data-product-variant-select]');
        var variantId = variantInput && variantInput.value;
        var qtyInput = form.querySelector('[name="quantity"]');
        var qty = parseInt(qtyInput && qtyInput.value ? qtyInput.value : '1', 10);
        if(!variantId) return;
        if(isNaN(qty) || qty < 1) qty = 1;
        var redirect = !!(submitter && submitter.matches('[data-product-add-main]'));
        var oldHtml = submitter ? submitter.innerHTML : '';
        if(submitter){ submitter.disabled = true; submitter.innerHTML = redirect ? 'Redirecting…' : 'Adding…'; }
        afAddVariantToCart(variantId, qty, redirect)
          .then(function(){
            if(!redirect && submitter){
              setTimeout(function(){ submitter.innerHTML = oldHtml; submitter.disabled = false; }, 800);
            }
          })
          .catch(function(){
            if(submitter){
              submitter.innerHTML = 'Try Again';
              setTimeout(function(){ submitter.innerHTML = oldHtml; submitter.disabled = false; }, 1200);
            }
          });
      });
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProductForms); else initProductForms();
  document.addEventListener('shopify:section:load', initProductForms);
})();


// Homepage best-seller hero carousel: auto-rotates selected best sellers without touching other sections.
(function(){
  function initBestSellerHeroCarousels(root){
    (root || document).querySelectorAll('[data-best-seller-carousel]').forEach(function(carousel){
      if(carousel.dataset.bestSellerReady === '1') return;
      var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-best-slide]'));
      var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-best-dot]'));
      if(slides.length <= 1){
        if(slides[0]) slides[0].classList.add('is-active');
        carousel.dataset.bestSellerReady = '1';
        return;
      }
      carousel.dataset.bestSellerReady = '1';
      var active = 0;
      var delay = parseInt(carousel.getAttribute('data-autoplay-ms') || '3000', 10);
      if(!delay || delay < 1500) delay = 3000;
      var timer = null;

      function paint(index){
        active = ((index % slides.length) + slides.length) % slides.length;
        var prev = (active - 1 + slides.length) % slides.length;
        var next = (active + 1) % slides.length;
        slides.forEach(function(slide, i){
          slide.classList.toggle('is-active', i === active);
          slide.classList.toggle('is-prev', i === prev);
          slide.classList.toggle('is-next', i === next);
        });
        dots.forEach(function(dot, i){ dot.classList.toggle('is-active', i === active); });
      }
      function stop(){ if(timer) window.clearInterval(timer); }
      function start(){ stop(); timer = window.setInterval(function(){ paint(active + 1); }, delay); }

      dots.forEach(function(dot, i){
        dot.addEventListener('click', function(){ paint(i); start(); });
      });
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', start);
      paint(0);
      start();
    });
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ initBestSellerHeroCarousels(document); });
  else initBestSellerHeroCarousels(document);
  document.addEventListener('shopify:section:load', function(e){ initBestSellerHeroCarousels(e.target || document); });
})();
